import { httpRequest } from "@services/http";

/** Accept a dashboard flag as fine. The server records it as an ingest Discrepancy (MPN-2010). */
export class CommandAcceptOpsFlag {
    async run(flagKey: string, subjectId: number, reason: string): Promise<void> {
        await httpRequest(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/ops-dashboard/flags/accept/`,
            { method: "POST", body: { flag_key: flagKey, subject_id: subjectId, reason } },
        );
    }
}
